export const getStyle = (type) => "text-align:left";

export const getFieldStyles = () => {
  return {
    field: [
      {
        backgroundColor: `white`, //'#f3f2f1',
        fontSize: "14px",
        color: "black",
        borderBottom: "1px solid lightGrey",
      },
    ],
  };
};

export const getTextBodyStyles = () => {
  return {
    field: [
      {
        backgroundColor: "#f3f2f1", //,
      },
    ],
  };
};

export const getHtmlBodyStyles = () => {
  return {
    backgroundColor: "#f3f2f1", //,
  };
};

export const lineStyle = () => {
  const _style = {
    marginTop: "1px",
    borderBottom: "1px solid blue"
    };
  return _style;
};

